import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from "configs/AppConfig";
import dayjs from "dayjs";
import { EXPIRE_TIME, REFRESH_TOKEN } from "constants/AuthConstant";
import { SSO_REFRESH_TOKEN } from "constants/ApiConstant";
import { setAuthenData } from "utils/helper";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import axios from "axios";

let isRefreshingToken = false;

const ProtectedRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  useEffect(() => {
    if (!token) return;

    const expiresTime = localStorage.getItem(EXPIRE_TIME);
    if (!expiresTime) return;

    const now = dayjs().add(3, "m");
    const expiresMoment = dayjs(Number(expiresTime) * 1000);
    const isExpired = expiresMoment.isBefore(now);

    if (!isExpired) return;
    if (isRefreshingToken) return;

    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    if (!refreshToken) {
      store.dispatch(signOutSuccess());
      return;
    }

    isRefreshingToken = true;

    axios
      .post(
        SSO_REFRESH_TOKEN,
        { refreshToken },
        {
          baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
          timeout: 10000,
        }
      )
      .then((res) => {
        if (res.data?.data) {
          setAuthenData(res.data.data);
        } else {
          throw new Error("Invalid refresh response");
        }
      })
      .catch(() => {
        store.dispatch(signOutSuccess());
      })
      .finally(() => {
        isRefreshingToken = false;
      });
  }, [token]);

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;